import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router';
import SelectDataset from '../SelectDataset';
import Accordion from '../Accordion';

const SelectForceProfile = ({
		callbackSelect, 
		indicator,
		secondIndicator, 
		locationPath,
		literals, 
		selectCountries,
		onCallbackCountry,
		callbackDataset, 
		filters,
		callbackResetFilter}) => {
    const [selectedTab, setSelectedTab] = useState(indicator);
    const [disabled, setDisabled]= useState("disabled");
    const [visible, setVisible]= useState(true);
    const [unselect, setUnselect]= useState(true);
    const [alert, setAlert] = useState(literals.L20694);
	const [subIndicator, setSubIndicator]= useState(secondIndicator);
	const [openSelectCountries, setOpenSelectCountries] = useState(false);
	const [datasetIndicator1, setDatasetIndicator1] = useState({ id: null, label: null });
	const [datasetIndicator2, setDatasetIndicator2] = useState({ id: null, label: null });
	const [datasetIndicator3, setDatasetIndicator3] = useState({ id: null, label: null });
	const [datasetIndicator4, setDatasetIndicator4] = useState({ id: null, label: null });
	const [reset, setReset] = useState(false);
	const countryDropdownRef = useRef();
		

    const history = useHistory();
    useEffect(() => {
        loadUrl();
    }, [selectedTab,subIndicator,indicator]);

	const loadUrl = ()=>{
		history.push({
			pathname: `${locationPath}${selectedTab}/${subIndicator}`
		})
	}

	useEffect(() => {
		addEventListener('mousedown', onHandleDropdown);

		if(indicator == 'employment-rate'){
			setDisabled("");
		}else{
			setDisabled("disabled");
			if(indicator == 'unemployment-rate'){
				setAlert(literals.L20741)
			}else{
				setAlert(literals.L20694)
			}
		}

		return () => {
			removeEventListener('mousedown', onHandleDropdown);
		}
	}, [])
 
	useEffect(() => {
		if(reset == true){
            setReset(false);
        }
	}, [reset])

	const onClickCountry = (countryCode) => {
		return () => {
			onCallbackCountry(countryCode)
		}
	}

	const openSelect = () => {
		setOpenSelectCountries(!openSelectCountries)
	}

	const onHandleDropdown = (e) => {
		if (countryDropdownRef.current && !countryDropdownRef.current.contains(e.target)) {
			setOpenSelectCountries(false)
		}
	}

	const selection = (e)=>{
		const option = e.target.value;
		callbackSelect(option);
		switch(option){
			case "employment-rate" :
				setDisabled("")
				setSelectedTab('employment-rate')
				break;
			case "ageing-workers" :
                setDisabled("")
				setSubIndicator('ageing-workers')
				break;
			case "median-age":
				setDisabled("disabled")
				setSelectedTab('median-age')
				setAlert(literals.L20694)
				setSubIndicator('ageing-workers')
			break;
			case "unemployment-rate":
				setDisabled("disabled")
				setSelectedTab('unemployment-rate')
				setAlert(literals.L20741)
				setSubIndicator('ageing-workers')
				break
			case "female":
				setSubIndicator('female')
				break
			case "male":
				setSubIndicator('male')
				break
			case "total":
				setSubIndicator('total')
				break
		}
	}

	const handleDataset1Change = (dataset, indicator, label) =>
	{
		setDatasetIndicator1({ id: dataset, label: label });
		callbackDataset(dataset, datasetIndicator2.id, datasetIndicator3.id, datasetIndicator4.id);
	}
	
	const handleDataset2Change = (dataset, indicator, label) =>
	{
		setDatasetIndicator2({ id: dataset, label: label });
		callbackDataset(datasetIndicator1.id, dataset, datasetIndicator3.id, datasetIndicator4.id);
	}

	const handleDataset3Change = (dataset, indicator, label) =>
	{
		setDatasetIndicator3({ id: dataset, label: label });
		callbackDataset(datasetIndicator1.id, datasetIndicator2.id, dataset, datasetIndicator4.id);
	}

	const handleDataset4Change = (dataset, indicator, label) =>
	{
		setDatasetIndicator4({ id: dataset, label: label });
		callbackDataset(datasetIndicator1.id, datasetIndicator2.id, datasetIndicator3.id, dataset);
	}

	const resetFilter = (e) => {
		setDatasetIndicator1({ id: null, label: null });
		setDatasetIndicator2({ id: null, label: null });
		setDatasetIndicator3({ id: null, label: null });
		setDatasetIndicator4({ id: null, label: null });
        e.preventDefault();
        setReset(true);
        callbackResetFilter();
    }

    return (
        <div className="" >
			<ul className="indicators--group xs-row">
				<li id="filter1">
					<label htmlFor="indicatorSelect">{literals.L20623}</label> 
					<select onChange={selection} id="indicatorSelect" className="filter--dropdown--list" value={selectedTab}>
						<option value="median-age">{literals.L294}</option>
						<option value="employment-rate">{literals.L20621}</option>
						<option value="unemployment-rate">{literals.L291}</option>
					</select>
				</li>
				<li id="filter2" className="disabled">
					<label htmlFor="employeeGroupSelect">{literals.L20622}</label> 
					{disabled ? (
						<select onChange={selection} id="employeeGroupSelect" className="filter--dropdown--list" disabled={disabled}>
							<option value="ageing-workers">{literals.L295}</option>
						</select>
					) : (
						<select onChange={selection} id="employeeGroupSelect" className="filter--dropdown--list" disabled={disabled} value={subIndicator}>
							<option value="ageing-workers">{literals.L295}</option>
							<option value="female">{literals.L444}</option>
							<option value="male">{literals.L443}</option>
							<option value="total">{literals.L442}</option>
						</select>
					)}
					{disabled ? <label className="alert-disabled "> {alert} </label> : true}
				</li>
				
				{/* COUNTRY FILTER JUST IN < 1024 PX */}
				<li id="filter3" className={`filter--dropdown--wrapper ${openSelectCountries ? 'viewOptions' : ''} `}>
				<label htmlFor="employeeGroupSelect">{literals.L20630}</label> 
					<div className="filter--dropdown--list" ref={countryDropdownRef}>
						<p className="option-title" onClick={openSelect}>{literals.L20630}</p>
						<ul className="filter--dropdown--options">
							{selectCountries.map((country) => (
								<li key={country.countryCode} onClick={onClickCountry({code: country.countryCode, name: country.countryName, data: country.data})}>
									<input type="checkbox" checked={filters.countries.find((countryFilters) => countryFilters.code == country.countryCode) ? true : false} readOnly />
									<label>{country.countryCode == 'EU27_2020' ? '' : `(${country.countryCode})`} {country.countryName}</label>
								</li>
							)
						)}
						</ul>
					</div>
				</li>
			</ul>

			<div className='container dataset--filter--block'>
				<div className="line full-line background-main-light"></div>
				<Accordion>
					<div className="accordion-title-with-labels">
						<div className='selected--dataset--info'>
							<label>{literals.L294}: {datasetIndicator1.label ? datasetIndicator1.label : ""}</label>	
							<label>{literals.L295}: {datasetIndicator2.label ? datasetIndicator2.label : ""}</label>
							<label>{literals.L296}: {datasetIndicator3.label ? datasetIndicator3.label : ""}</label>	
							<label>{literals.L291}: {datasetIndicator4.label ? datasetIndicator4.label : ""}</label>	
						</div>
						
						<h3 className="accordion-title-text">{ literals.L20064 }</h3>
					</div>
					<div className="accordion-content">
						<ul className='select--dataset--list'>
							<li className='col-12 col-md-6 col-lg-3'>
								{/*Median age population*/}
								<label>{literals.L294}</label>
								<SelectDataset
									chart={ '20012' }
									indicator = { '37' }
									handleDatasetChange= { handleDataset1Change }
									reset={reset}
								/>
							</li>
							<li className='col-12 col-md-6 col-lg-3'>
                        		{/*Employment rate - Ageing workers*/}
								<label>{literals.L295}</label>
								<SelectDataset
									chart={ '20012' }
									indicator = { ['38']}
									handleDatasetChange= { handleDataset2Change }
									reset={reset}
								/>
							</li>
							<li className='col-12 col-md-6 col-lg-3'>
                        		{/*Employment rate - Total, Male & Female*/}
								<label>{literals.L296}</label>
								<SelectDataset
									chart={ '20012' }
									indicator = { ['39']}
									handleDatasetChange= { handleDataset3Change }
									reset={reset}
								/>
							</li>
							<li className='col-12 col-md-6 col-lg-3'>
								{/*Unemployment rate*/}
                        		<label>{literals.L291}</label>
								<SelectDataset
									chart={ '20012' }
									indicator={ '34' }
									handleDatasetChange={ handleDataset4Change }
									reset={reset}
								/>
							</li>
						</ul>
						<div className='dataset-filter-buttons'>
							<button className='btn-default btn-main-color' onClick={(e) => resetFilter(e)}>{ literals.L20628 }</button>
						</div>
					</div>
				</Accordion>	
			</div>
		</div>
    )
}

export default SelectForceProfile;